import { render, staticRenderFns } from "./DropdownCard.vue?vue&type=template&id=6807565e&scoped=true&"
import script from "./DropdownCard.vue?vue&type=script&lang=js&"
export * from "./DropdownCard.vue?vue&type=script&lang=js&"
import style0 from "./DropdownCard.vue?vue&type=style&index=0&id=6807565e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6807565e",
  null
  
)

export default component.exports